import React from 'react'
import PropTypes from 'prop-types'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { openURIInApp } from '../../utils/URLSchemeHelper'
import home_images from '../../assets/images/home/*.svg'


class Maintenance extends React.Component {
  static contextTypes = {
    intl: PropTypes.object
  }

  render() {
    return (
      <div className="d-Error">
        <div className="d-Error-Inner">
          <img src={home_images["home_maintenance"]} />
        </div>
      </div>    
    )
  }
}

export default Maintenance
